import styles from "../../styles/Forms.module.css";
import React from "react";
import LateralMenu from "../../components/LateralMenu/LateralMenu";
import Tabs from "../../components/Tabs/Tabs";
import DragAndDrop from "../../components/DragAndDrop/DragAndDrop";
import { useContext, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { checkMissingSections, exportExcel } from "../../utils/excel";
import ButtonComp from "../../components/Button/Button";
import { authService } from "../../services/auth.service";
import { ImageView } from "../../contexts/imageView";
import { ModalComp } from "../../components/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { pesquisaApi } from "../../services/apiPesquisa.servise";
import cloneDeep from "lodash.clonedeep";
import {
  saveChange,
  setAllSegments,
  setDuplicateImagesId,
  setImagens,
  setAllSegmentsSaved,
} from "../../store/reducers/dadosSegmentos";
import { formState } from "../../store/reducers/data";
import { Typography, Chip, Snackbar, Alert, CircularProgress } from "@mui/material";
import CustomModal from "../../components/CustomModal/CustomModal";

export default function Search() {
  const user = authService.getLoggedUsername();
  const userEmail = authService.getLoggedUserEmail();
  const userObj = authService.getLoggedUser();
  const isAdm = userObj?.isAdm || false;

  const slices = useSelector((state) => state);
  const state = { ...slices.dadosSegmentos, ...slices.dadosHeader };
  const roadName = state.RoadName;
  const snippet = state.snippet;
  const idHeader = state.idHeader;
  const status = state.status;
  const statusDisplay = state.status_display;

  const [dataImport, setDataImport] = useState();
  const images = "";

  const [openModal, setOpenModal] = useState(false);
  const [openModalSave, setOpenModalSave] = useState(false);
  const [openModalRepetidas, setOpenModalRepetidas] = useState(false);
  const [openModalUnsaved, setOpenModalUnsaved] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [itensFaltando, setItensFaltando] = useState([]);
  const [unsavedSections, setUnsavedSections] = useState([]);
  const [hasDuplicateImages, setHasDuplicateImages] = useState(false);
  const [isReloading, setIsReloading] = useState(false);
  const { imageView, dispatchImageView } = useContext(ImageView);
  const dispatch = useDispatch();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const canEdit = () => {
    if (status === "COMPLETED") return false;
    if (status === "REVIEW" && !isAdm) return false;
    return true;
  };

  const handleClose = () => {
    setOpenModal(false);
    setOpenModalSave(false);
    setOpenModalUnsaved(false);
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

const reloadSections = async () => {
  if (!idHeader) return;
  setIsReloading(true);
  try {
    const res = await pesquisaApi.getSections(idHeader);
    let arrayState = Array(res.data.length)
      .fill()
      .map(() => cloneDeep(formState));
    let data = await res.data;
    data.sort((a, b) => a.id_section - b.id_section);
    let imagens = [];
    let imagensRepetidas = [];
    const imgRefServidor = [];

    data.forEach((obj) => {
      for (let _data in obj) {
        if (
          _data === "centre_0" ||
          _data === "centre_20" ||
          _data === "centre_40" ||
          _data === "centre_60" ||
          _data === "centre_80"
        ) {
          imagens.push(obj[_data]);
        }
      }
      let imageName;
      if (obj["image_reference"]?.includes("_")) {
        const imageReferenceArrayClear = obj["image_reference"].split("_");
        const extension = imageReferenceArrayClear[1].split(".");
        imageName = `${imageReferenceArrayClear[0]}.${extension[1]}`;
      } else {
        imageName = obj["image_reference"];
      }
      if (imgRefServidor.includes(imageName)) {
        imagensRepetidas.push(obj["id_section"]);
      } else {
        imgRefServidor.push(imageName);
      }
    });
    dispatch(setImagens({ imagens }));
    dispatch(setDuplicateImagesId(imagensRepetidas));
    const hasDuplicates = imagensRepetidas.length > 0;
    setHasDuplicateImages(hasDuplicates);
    if (hasDuplicates) {
      setOpenModalRepetidas(true);
    }
    arrayState.forEach((item, i) => {
      item.forEach((parametro, j) => {
        for (let datas in data[i]) {
          if (datas === parametro.varName) {
            parametro.selecionado.code = data[i][datas];
            parametro.label.forEach((option) => {
              if (option.code === data[i][datas]) {
                parametro.selecionado.title = option.title;
              }
            });
            arrayState[i][j].selecionado.code = data[i][datas];
          }
        }
      });
    });

    dispatch(setAllSegments({
      segmentos: arrayState,
      length: arrayState.length,
      preservePage: true,
    }));
    dispatch(setAllSegmentsSaved({ saved: true }));

    return arrayState;
  } catch (error) {
    console.error("Erro ao recarregar seções:", error);
    throw error;
  } finally {
    setIsReloading(false);
  }
};

  const refreshAll = async () => {
    await reloadSections();
  };


  const uploadSection = async (segmentos) => {
    const formData = new FormData();
    formData.append("header", idHeader);
    let id;
    Object.keys(segmentos).forEach((item) => {
      if (segmentos[item].varName === "id_section") {
        id = segmentos[item].selecionado.code;
      }
      if (segmentos[item].selecionado.code) {
        formData.append(segmentos[item].varName, segmentos[item].selecionado.code);
      }
    });
    formData.delete("image_reference");
    formData.delete("centre_0");
    formData.delete("centre_20");
    formData.delete("centre_40");
    formData.delete("centre_60");
    formData.delete("centre_80");
    await pesquisaApi.uploadSections(formData, id);
  };

  const handleSaveAllSections = async () => {
    setOpenBackdrop(true);
    try {
      const unsavedIndices = state.savedStatus
        .map((saved, idx) => ({ saved, idx }))
        .filter((item) => !item.saved)
        .map((item) => item.idx);

      if (unsavedIndices.length === 0) {
        setOpenBackdrop(false);
        setOpenModalUnsaved(false);
        return;
      }

      for (const idx of unsavedIndices) {
        await uploadSection(state.segmentos[idx]);
        dispatch(saveChange({ index: idx }));
      }

      // Após salvar todos, recarregar para atualizar coding_date
      await reloadSections();

      setOpenBackdrop(false);
      setOpenModalUnsaved(false);
      setSnackbar({
        open: true,
        message: `✅ ${unsavedIndices.length} trecho(s) salvos com sucesso!`,
        severity: "success",
      });
    } catch (error) {
      setOpenBackdrop(false);
      setSnackbar({
        open: true,
        message: `Erro ao salvar trechos: ${error.message}`,
        severity: "error",
      });
    }
  };


  async function doExport() {
    try {
      await reloadSections();

      const currentState = { ...slices.dadosSegmentos, ...slices.dadosHeader };

      // Exportar o Excel com os dados atualizados
      exportExcel(user, roadName, snippet, currentState, userEmail);

      // Mudar status para REVISION se ainda não estiver
      if (status !== "REVIEW" && status !== "COMPLETED") {
        await pesquisaApi.markAsReview(idHeader);
        await pesquisaApi.completeCodification(idHeader);

        dispatch({
          type: "dadosHeader/setHeader",
          payload: {
            ...currentState,
            status: "REVIEW",
            status_display: "Em Revisão",
          },
        });
        setSnackbar({
          open: true,
          message: "Exportação concluída! Codificação enviada para revisão.",
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: "Dados exportados com sucesso.",
          severity: "info",
        });
      }
    } catch (error) {
      console.error("Erro na exportação ou mudança de status:", error);
      setSnackbar({
        open: true,
        message: `Erro ao exportar: ${error.message}`,
        severity: "error",
      });
    }
  }

  const handleApprove = async () => {
    try {
      await pesquisaApi.approveHeader(idHeader);

      dispatch({
        type: "dadosHeader/setHeader",
        payload: {
          ...state,
          status: "COMPLETED",
          status_display: "Concluído",
        },
      });

      setSnackbar({
        open: true,
        message: "Codificação aprovada e concluída com sucesso!",
        severity: "success",
      });
    } catch (error) {
      console.error("Erro ao aprovar:", error);
      setSnackbar({
        open: true,
        message: `❌ Erro ao aprovar: ${error.message}`,
        severity: "error",
      });
    }
  };

  async function handleExportExcel() {
    if (hasDuplicateImages) {
      setOpenModalRepetidas(true);
      return;
    }

    // Verificar trechos não salvos
    const unsavedIndices = state.savedStatus
      .map((saved, idx) => ({ saved, idx }))
      .filter((item) => !item.saved)
      .map((item) => item.idx + 1);

    if (unsavedIndices.length > 0) {
      setUnsavedSections(unsavedIndices);
      setOpenModalUnsaved(true);
      return;
    }

    // Verificar trechos incompletos
    const faltantes = checkMissingSections(state.segmentos);
    if (faltantes.length !== 0) {
      setOpenModal(true);
      setItensFaltando(faltantes);
      return;
    }

    await doExport();
  }

  const handleConfirmExportWithMissing = async () => {
    setOpenModal(false);
    await doExport();
  };

  useEffect(() => {
    const getSearch = async () => {
      if (!idHeader) return;
      try {
        await reloadSections();

        // Registrar início da codificação
        try {
          await pesquisaApi.startCodification(idHeader);
        } catch (error) {
          console.warn("Erro ao registrar início:", error);
        }
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
        setSnackbar({
          open: true,
          message: "Erro ao carregar codificação",
          severity: "error",
        });
      }
    };

    getSearch();
  }, [idHeader]);

  return (
    <>
      <LateralMenu isForm={true} />
      <main>
        {/* Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
            {snackbar.message}
          </Alert>
        </Snackbar>

        {/* Loading (backdrop) */}
        {openBackdrop && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              bgcolor: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <CircularProgress color="primary" />
            <Typography sx={{ ml: 2, color: "white" }}>Salvando trechos...</Typography>
          </Box>
        )}

        {/* Modal: Imagens duplicadas */}
        <ModalComp
          open={openModalRepetidas}
          title={"Imagens duplicadas detectadas"}
          subtitle={
            "Identificamos imagens repetidas. Solicite ao seu supervisor a remoção das duplicatas antes de prosseguir."
          }
        >
          <Button onClick={() => setOpenModalRepetidas(false)}>Ok</Button>
        </ModalComp>

        {/* Modal de trechos não salvos */}
        <CustomModal
          open={openModalUnsaved}
          onClose={() => setOpenModalUnsaved(false)}
          title="Trechos não salvos"
          subtitle="Os seguintes trechos não foram salvos. Deseja salvá-los agora?"
        >
          <Box>
            <Typography>
              Trechos não salvos: <strong>{unsavedSections.join(', ')}</strong>
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
              <Button variant="contained" onClick={handleSaveAllSections}>
                Salvar todos
              </Button>
              <Button variant="outlined" onClick={() => setOpenModalUnsaved(false)}>
                Cancelar
              </Button>
            </Box>
          </Box>
        </CustomModal>

        {/* Modal: Trechos incompletos */}
        {itensFaltando.length > 0 && (
          <ModalComp
            title={"Codificação incompleta"}
            subtitle={"Os seguintes trechos estão incompletos:"}
            open={openModal}
          >
            <Box>
              {itensFaltando.map((item, index) => (
                <div key={index}>
                  <Typography variant="h6">Trecho {item.trecho}</Typography>
                  <Typography>Itens faltantes:</Typography>
                  {item.faltantes.map((faltante, idx) => (
                    <Typography key={idx} color="error">
                      • {faltante}
                    </Typography>
                  ))}
                </div>
              ))}
              <Typography sx={{ mt: 2 }}>Deseja continuar mesmo assim?</Typography>
              <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                <Button variant="contained" onClick={handleConfirmExportWithMissing}>
                  Sim
                </Button>
                <Button variant="outlined" onClick={() => setOpenModal(false)}>
                  Não
                </Button>
              </Box>
            </Box>
          </ModalComp>
        )}

        {/* Modal: Seções não salvas (fallback) */}
        {state.isSave === false && (
          <ModalComp
            title={"Seções não salvas"}
            subtitle={"Por favor, salve as seções antes de exportar."}
            open={openModalSave}
          >
            <Button onClick={handleClose}>Ok</Button>
          </ModalComp>
        )}

        <div
          className={imageView.hasFlex ? styles.imageViewFlex : styles.imageViewDefault}
          style={
            imageView.hasFlex
              ? {
                paddingTop: 65,
                paddingBottom: 0,
                marginTop: 0,
                marginBottom: 0,
                alignItems: "flex-start",
              }
              : undefined
          }
        >
          <Box
            sx={{
              alignSelf: "flex-start",
              ...(imageView.hasFlex && { marginTop: "-85px" }),
            }}
          >
            <DragAndDrop
              data={dataImport}
              images={images}
              hasNew={false}
              disabled={!canEdit()}
              onRefreshAll={refreshAll}
              onShowSaveAllModal={(indices) => {
                setUnsavedSections(indices);
                setOpenModalUnsaved(true);
              }}
            />
          </Box>

          <div className={styles.rightColumn}>
            <Box
              sx={{
                mb: 1,
                ml: "12px",
                mr: "22px",

                px: 2,
                py: 1.5,

                bgcolor: "#FFFFFF",
                border: "solid 1px grey",
                borderRadius: "8px",

                display: "flex",
                alignItems: { xs: "flex-start", md: "center" },
                justifyContent: "space-between",
                flexDirection: { xs: "column", md: "row" },
                gap: 1.5,

                position: "relative",
              }}
            >
              {/* Via */}
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#667085",
                    fontWeight: 500,
                    display: "block",
                    mb: 0.2,
                  }}
                >
                  Via em codificação
                </Typography>

                <Typography
                  sx={{
                    color: "var(--goia-navy, #091D42)",
                    fontWeight: 700,
                    fontSize: "1.05rem",
                    lineHeight: 1.25,

                    // evita quebrar demais quando o nome da via for grande
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: { xs: "normal", sm: "nowrap" },
                  }}
                >
                  {roadName || "Via não informada"}
                </Typography>
              </Box>

              {/* Informações secundárias */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1,
                  flexShrink: 0,
                }}
              >
                <Chip
                  label={`Trecho ${snippet || "—"}`}
                  size="small"
                  sx={{
                    bgcolor: "#F2F4F7",
                    color: "#344054",
                    fontWeight: 600,
                    border: "1px solid #EAECF0",
                  }}
                />

                <Chip
                  label={`ID #${idHeader || "—"}`}
                  size="small"
                  variant="outlined"
                  sx={{
                    color: "#667085",
                    fontWeight: 500,
                    borderColor: "#D0D5DD",
                  }}
                />

                <Chip
                  label={statusDisplay || "Em Andamento"}
                  color={
                    status === "COMPLETED"
                      ? "success"
                      : status === "REVIEW"
                        ? "warning"
                        : "info"
                  }
                  size="small"
                  sx={{
                    fontWeight: 600,
                  }}
                />

                {isReloading && (
                  <CircularProgress size={18} />
                )}
              </Box>
            </Box>

            <Tabs
              data={dataImport}
              dadosDoCod={{
                nome: user,
                roadName: roadName,
                snippet: snippet,
              }}
              disabled={!canEdit()}
            />

            <Box
              sx={{
                marginTop: "10px",
                marginBottom: "10px",
                display: "flex",
                justifyContent: "end",
                gap: 1,
              }}
            >
              <ButtonComp
                onClick={() => {
                  let latitude = "";
                  let longitude = "";
                  const idx = state.paginaAtual - 1;
                  Object.keys(state.segmentos[idx] || {}).forEach((item) => {
                    if (state.segmentos[idx][item].title === "Latitude") {
                      latitude = state.segmentos[idx][item].selecionado.code;
                    } else if (state.segmentos[idx][item].title === "Longitude") {
                      longitude = state.segmentos[idx][item].selecionado.code;
                    }
                  });
                  if (latitude && longitude) {
                    window.open(`https://www.google.com/maps?q=${latitude},${longitude}`);
                  } else {
                    setSnackbar({
                      open: true,
                      message: "Latitude/Longitude não disponíveis para este trecho.",
                      severity: "warning",
                    });
                  }
                }}
              >
                Abrir no mapa
              </ButtonComp>

              {isAdm && status === "REVIEW" && (
                <ButtonComp
                  sx={{
                    backgroundColor: "success.main",
                    "&:hover": { backgroundColor: "success.dark" },
                  }}
                  onClick={handleApprove}
                >
                  Aprovar e Concluir
                </ButtonComp>
              )}

              <ButtonComp
                sx={{ marginRight: "20px" }}
                onClick={() => {
                  if (state.isSave === true) {
                    handleExportExcel();
                  } else {
                    setOpenModalSave(true);
                  }
                }}
                disabled={isReloading}
              >
                Exportar dados
              </ButtonComp>
            </Box>
          </div>
        </div>
      </main>
    </>
  );
}